import React from 'react';
import ReactDOM from "react-dom"
// import { ApolloConsumer } from 'react-apollo';
import Box from './Box';
import { getSetCurrency } from '../../multi_currency';
import { ApolloClient } from 'apollo-client';
import { ApolloConsumer } from 'react-apollo';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloProvider } from 'react-apollo';
import { GRAPHQL_URI, STOREFRONT_TOKEN, GRAPHQL_URI_CAD, STOREFRONT_TOKEN_CAD, SHOP_URL, SHOP_NAME, SHOP_URL_CAD, SHOP_NAME_CAD } from '../../constants';

const setCurrency = getSetCurrency();

const apiCreds = {
	storefrontToken: STOREFRONT_TOKEN,
	graphqlUri: GRAPHQL_URI,
	shopUrl: SHOP_URL,
	shopName: SHOP_NAME
}

const httpLink = createHttpLink({
	uri: apiCreds.graphqlUri
});

const middlewareLink = setContext(() => ({
	headers: {
		'X-Shopify-Storefront-Access-Token': apiCreds.storefrontToken
	}
}));

const client = new ApolloClient({
	link: middlewareLink.concat(httpLink),
	cache: new InMemoryCache()
});

const BoxContainer = (props) => {
	console.log("IN REACT")
	return (
		<ApolloConsumer>
			{client => (
				<React.Fragment>
					<Box
						client={client}
						setCurrency="USD"
						apiCreds={apiCreds}
					/>
		 		</React.Fragment>
		 	)}
		</ApolloConsumer>
	)
}

export default BoxContainer;

const rootEl = document.getElementById("root")
document.addEventListener('DOMContentLoaded', () => {
	ReactDOM.render(
		<ApolloProvider client={client}>
			<BoxContainer/>
		</ApolloProvider>,
		rootEl
	)
})